import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor, HttpResponse,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { Observable, of, throwError, timer } from 'rxjs';
import {catchError, delay, map, switchMap, timeout} from 'rxjs/operators';
import { LoadingService } from 'src/app/_services/ui/loading/loading.service';
import { API, ENVIRONMENT } from '../_constants/app.constants';

/**
 * This class is for intercepting http requests. When a request starts, we set the loadingSub property
 * in the LoadingService to true. Once the request completes and we have a response, set the loadingSub
 * property to false. If an error occurs while servicing the request, set the loadingSub property to false.
 * @class {HttpRequestInterceptor}
 */
@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  private ignore: any = [
    `${ENVIRONMENT.PROPERTIES.apiUrl}${API.AUTH}`,
    `${ENVIRONMENT.PROPERTIES.apiUrl}${API.WEBEX}`
  ];

  constructor(
    private _loading: LoadingService
  ) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!(this.ignore).includes(request.url)) this._loading.setLoading(true, request.url);
    return next.handle(request)
      .pipe(catchError((err) => {
        this._loading.setLoading(false, request.url);
        return throwError(() => new Error(err));
      }))
      .pipe(map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
        if (evt instanceof HttpResponse) {
          this._loading.showIndicator = true;
          this._loading.setLoading(false, request.url);
        }
        return evt;
      }));
  }
}

export const LoadingProvider = {
  // use fake backend in place of Http service for backend-less development
  provide: HTTP_INTERCEPTORS,
  useClass: LoadingInterceptor,
  multi: true
};
